import React, { useEffect, useState, useRef } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { useProjectFilter, AVAILABLE_PROJECTS } from '../contexts/ProjectFilterContext';
import { motion, AnimatePresence } from 'framer-motion';
export function ProjectSelector() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const {
    selectedProjects,
    isProjectSelected,
    toggleProject,
    setSelectedProjects
  } = useProjectFilter();
  const allSelected = selectedProjects.length === AVAILABLE_PROJECTS.length;
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);
  const getDisplayText = () => {
    if (selectedProjects.length === 0) {
      return 'No Sites';
    }
    if (allSelected) {
      return 'All Sites';
    }
    if (selectedProjects.length === 1) {
      return selectedProjects[0];
    }
    return `${selectedProjects.length} Sites`;
  };
  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedProjects([]);
    } else {
      setSelectedProjects(AVAILABLE_PROJECTS);
    }
  };
  return <div className="relative" ref={dropdownRef} data-id="element-3007">
      <button onClick={() => setIsOpen(!isOpen)} className="bg-white text-black text-sm px-3 py-1.5 pr-8 rounded w-48 focus:outline-none focus:ring-2 focus:ring-emerald-500 text-left flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-3008">
        <span className="truncate" data-id="element-3009">{getDisplayText()}</span>
        <ChevronDown size={14} className={`absolute right-2 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-3010" />
      </button>

      <AnimatePresence data-id="element-3011">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.15
      }} className="absolute top-full mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50 right-0" data-id="element-3012">
            {/* Select All option */}
            <button onClick={handleSelectAll} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors flex items-center justify-between border-b border-gray-100 mb-1 pb-3" data-id="element-3013">
              <span className="font-medium text-gray-900" data-id="element-3014">
                {allSelected ? 'Deselect All' : 'Select All'}
              </span>
              {allSelected && <div className="w-4 h-4 bg-emerald-500 rounded flex items-center justify-center" data-id="element-3015">
                  <Check size={12} className="text-white" data-id="element-3016" />
                </div>}
            </button>

            {/* Individual projects */}
            {AVAILABLE_PROJECTS.map(project => {
          const isSelected = isProjectSelected(project);
          return <button key={project} onClick={() => toggleProject(project)} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-3017">
                  <span className={isSelected ? 'text-gray-900' : 'text-gray-600'} data-id="element-3018">
                    {project}
                  </span>
                  {isSelected && <div className="w-4 h-4 bg-emerald-500 rounded flex items-center justify-center" data-id="element-3019">
                      <Check size={12} className="text-white" data-id="element-3020" />
                    </div>}
                </button>;
        })}

            {/* Footer info */}
            <div className="px-4 py-2 text-xs text-gray-500 border-t border-gray-100 mt-1 pt-3" data-id="element-3021">
              {selectedProjects.length} of {AVAILABLE_PROJECTS.length} selected
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}